import { useEffect, useState } from "react";
import { PreviewSelector } from "../../views/Slides/previews";
import { mergeClass } from "../../utils";
import { WorkOrPhotosPreview } from "../../views/WorkOrPhotos/previews/WorkOrPhotosPreview";

export const SlidePreviewDisplay = ({
  item,
  itemName,
  modelName,
}: {
  item: any;
  itemName: string;
  modelName: string;
}) => {
  const itemId = `preview-${item.id}`;
  // [width, height, xoffset]
  const [size, setSize] = useState<[number, number, number]>([180, 236, 0]);

  useEffect(() => {
    const previewElement = document.getElementById(itemId);
    if (previewElement) {
      const rect = previewElement?.getBoundingClientRect();
      setSize([rect.width, rect.height, Math.max(180 - rect.width, 0) / 2]);
    }
  }, []);

  const isSlides = modelName === "slides";

  return (
    <>
      <div className="relative w-fit h-fit bg-black">
        <div style={{ width: Math.max(size[0], 180), height: size[1] }} />
        {isSlides ? (
          <div
            id={itemId}
            className={`absolute origin-top-left top-0 left-0 max-h-[22rem] overflow-hidden pointer-events-none`}
            style={{
              transform: `translate(${size[2]}px, 0) scale(0.65)`,
            }}
          >
            <PreviewSelector
              screenType={item.screenType}
              itemData={item}
              forSlides={true}
            />
          </div>
        ) : (
          <div
            id={itemId}
            className={
              "origin-top-left absolute top-0 left-0 scale-[0.7] pointer-events-none"
            }
          >
            <WorkOrPhotosPreview itemData={item} forIndex />
          </div>
        )}
      </div>
      <div
        className={mergeClass(
          "bg-grayBg grid place-content-center text-white text-sm font-medium px-1",
          {
            "h-14": !isSlides,
            "py-2": isSlides,
          }
        )}
        style={{ width: Math.max(size[0], 180) }}
      >
        {itemName}
      </div>
    </>
  );
};
